<script setup lang="ts">
// Admin / operations console sidebar (doc 04 §9.1).
interface AdminNavItem {
  title: string
  icon: string
  to: string
}

const nav: AdminNavItem[] = [
  { title: 'Dashboard', icon: 'mdi-view-dashboard', to: '/admin' },
  { title: 'Users', icon: 'mdi-account-multiple', to: '/admin/users' },
  { title: 'Verification', icon: 'mdi-check-decagram', to: '/admin/players/verify' },
  { title: 'Geography', icon: 'mdi-map', to: '/admin/geography' },
  { title: 'Audit Log', icon: 'mdi-file-document-outline', to: '/admin/audit' },
  { title: 'Settings', icon: 'mdi-cog', to: '/admin/settings' },
]
</script>

<template>
  <v-navigation-drawer color="secondary" theme="dark" permanent>
    <v-list nav>
      <v-list-item
        v-for="item in nav"
        :key="item.to"
        :to="item.to"
        :prepend-icon="item.icon"
        :title="item.title"
      />
    </v-list>
  </v-navigation-drawer>
</template>
